import React, { useState, useCallback } from "react";
import MaterialTable from '@material-table/core';
import Checkbox from "@mui/material/Checkbox";

const VolunteerList = ({volunteers, changeVolunteer, makeAdmin}) => {
    const [selectedRowId, setSelectedRowId] = useState(0)

    const ToggleActive = async (selectedRow) => {
      if (! window.confirm('gebruiker ' + selectedRow.username + (selectedRow.enabled ? " deactiveren?" : " activeren?"))) {
        console.log("Not approved")
        return 
      }
      console.log(selectedRow)
      changeVolunteer(selectedRow.username, ! selectedRow.enabled)
    }

    const queryMakeAdmin = async (selectedRow) => {
      console.log("queryMakeAdmin: ", selectedRow);
      if (selectedRow.groups.includes("admin")) {
        window.alert('Gebruiker ' + selectedRow.username + ' is al Admin. Terugzetten is hier (nog) niet mogelijk.')
        return
      } else if (! window.confirm('Wilt u gebruiker ' + selectedRow.username + " Admin maken?")) {
        console.log("Not approved")
        return 
      }
      console.log(selectedRow)
      makeAdmin(selectedRow.username)
    }

    const checkBoxActive = useCallback((rowData) => {
      return (
        <Checkbox
          checked={rowData.enabled}
          onChange={(e) => ToggleActive(rowData) }
          inputProps={{ 'aria-label': 'controlled' }}
          disabled={(rowData.username === "test_admin" || rowData.username === "test_volunteer")}
        /> );
    }, []);

    const checkBoxAdmin = useCallback((rowData) => {
      return (
        <Checkbox
          checked={rowData.admin}
          onChange={(e) => queryMakeAdmin(rowData) }
          inputProps={{ 'aria-label': 'controlled' }}
          disabled={(rowData.username === "test_volunteer")}
          sx={{
              color: 'text.secondary',
              '&.Mui-checked': {
              color: 'text.disabled',
              }
          }}
        /> );
    }, []);

    return (
      <div>
      {volunteers.length > 0 && <MaterialTable
        // icons={tableIcons}
        localization={{
          pagination: {
            labelDisplayedRows: '{from}-{to} van {count}',
            labelRowsSelect: 'Rijen',
            labelRowsPerPage: 'Rijen per pagina:',
            firstAriaLabel: 'Eerste pagina',
            firstTooltip: 'Eerste pagina',
            previousAriaLabel: 'Vorige pagina',
            previousTooltip: 'Vorige pagina',
            nextAriaLabel: 'Volgende pagina',
            nextTooltip: 'Volgende pagina',
            lastAriaLabel: 'Laatste pagina',
            lastTooltip: 'Laatste pagina'
          },
          toolbar: {
            addRemoveColumns: 'Verwijder of voeg kolommen toe',
            nRowsSelected: '{0} rij(en) geselecteerd',
            showColumnsTitle: 'Toon kolommen',
            showColumnsAriaLabel: 'Toon kolommen',
            exportTitle: 'Export',
            exportAriaLabel: 'Export',
            exportName: 'Export als CSV',
            searchTooltip: 'Zoeken',
            searchPlaceholder: 'Zoeken'
            },
          header: {
              actions: 'Acties'
          },
          body: {
              emptyDataSourceMessage: 'Er zijn geen resultaten',
              filterRow: {
                  filterTooltip: 'Filter'
              }
          }
        }}
        options={{
          pageSize: 10,
          headerStyle: { position: 'sticky', top: 0, fontWeight: 'bold', color:"white", backgroundColor: '#019ce2' },
          rowStyle: (rowData, index) => ({
            backgroundColor:
              rowData.tableData.id === selectedRowId
                ? (index % 2) === 0 ? "#e1f3fc" : "#f2fafd" // For now we do not use color for selected row - We did use: "#6ABAC9"
                : (index % 2) === 0 ? "#e1f3fc" : "#f2fafd"
          }),
          tableLayout: "fixed",
          padding: "dense"
        }}
        title="Vrijwilligers"
        columns={[
          {
            title: "ID",
            field: "id",
            hidden: true,
            width: 0
          },
          {
            title: "Username",
            field: "username",
            width: "15%"
          },
          {
            title: "Email",
            field: "email",
            width: "22%"
          },
          {
            title: "Status",
            field: "status",
            width: "22%"
          },
          {
            title: "Actief",
            field: "enabled",
            width: "8%",
            render: checkBoxActive
          },
          {
            title: "Vrijwilliger",
            field: "volunteer",
            type: 'boolean',
            width: "8%"
          },
          {
            title: "Admin",
            field: "admin",
            width: "8%",
            render: checkBoxAdmin
          },
          {
            title: "CGI",
            field: "cgi",
            type: 'boolean',
            width: "8%"
          },
          {
            title: "Rollen",
            field: "groups",
            minWidth: 300,
            hidden: true,
            width: 0
          }

        ]}
        data={volunteers}
        // ---- Add again from here -------
        onRowClick={(event, rowData) => {
        // if the rowData.tableDate.id could be used on condidtional render
          console.log(rowData);
          setSelectedRowId(rowData.tableData.id);
        }}
        // ---- Up to here --------
      />}  
    </div>
    );
  }

export default VolunteerList;
